module.exports = __webpack_public_path__ + "static/media/shopify3.22322818.png";